import { createServerSideRequestOption } from "@/redux/config";

// api/permissionService.ts
const BASE_PATH = "/permissions";

export class PermissionService {
  private static async fetchWithServerRequest(options: {
    url: string;
    request: Request;
    method: "GET" | "POST" | "PUT" | "DELETE";
    body?: unknown;
  }) {
    const res = await createServerSideRequestOption({
      url: options.url,
      request: options.request,
      method: options.method,
      body: options.body,
    });

    if (!res.ok) throw new Error(`API Error: ${res.statusText}`);
    return res.json();
  }

  static getEndpointUrl(params: { companyId?: number }, suffix = "") {
    return `/c/${params.companyId ?? 0}${BASE_PATH}${suffix}`;
  }

  static async listCompanyResources(
    params: { companyId: number; groupId?: number },
    request: Request
  ): Promise<CompanyPermissionRole[]> {
    const url = this.getEndpointUrl(params, `/resources`);
    return this.fetchWithServerRequest({
      url,
      request,
      method: "GET",
      body: { groupId: params.groupId },
    });
  }

  static async listPermissionGroups(
    params: PermissionListParams,
    request: Request
  ): Promise<CompanyPermissionGroup[]> {
    const url = this.getEndpointUrl(params);
    return this.fetchWithServerRequest({
      url,
      request,
      method: "GET",
      body: { search: params.search },
    });
  }

  static async createPermissionGroup(
    params: { companyId: number },
    data: PermissionGroupData,
    request: Request
  ): Promise<CompanyPermissionGroup> {
    const url = this.getEndpointUrl(params);
    return this.fetchWithServerRequest({
      url,
      request,
      method: "POST",
      body: data,
    });
  }

  static async updatePermissionGroup(
    params: { companyId: number; permissionId: number },
    data: PermissionGroupData,
    request: Request
  ): Promise<CompanyPermissionGroup> {
    const url = this.getEndpointUrl(params, `/${params.permissionId}`);
    return this.fetchWithServerRequest({
      url,
      request,
      method: "PUT",
      body: data,
    });
  }

  static async deletePermissionGroup(
    params: { companyId: number; permissionId: number },
    request: Request
  ): Promise<void> {
    const url = this.getEndpointUrl(params, `/${params.permissionId}`);
    await this.fetchWithServerRequest({ url, request, method: "DELETE" });
  }
}
